<template>
  <div v-if="data.social_url">
    <div v-if="isYouTubeLink(data.social_url)" class="video-container">
      <iframe class="w-100 h-100" :src="getYouTubeUrl(data.social_url)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
      <div v-else>
        <a :href="data.social_url">
          <img src="/img/SLMath/SLMath_news_default.jpg" onerror="this.onerror=null;this.src='/img/SLMath/SLMath_news_default.jpg';" class="card-img-top"/>
        </a>
      </div>
  </div>
  <div v-else-if="data.thumbnail_url">
    <img :src="data.thumbnail_url" onerror="this.onerror=null;this.src='/img/SLMath/SLMath_news_default.jpg';" class="card-img-top my-1"/>
  </div>
  <div v-else>
    <img src="/img/SLMath/SLMath_news_default.jpg" onerror="this.onerror=null;this.src='/img/SLMath/SLMath_news_default.jpg';" class="card-img-top my-1"/>
  </div>
</template>

<script>
import { getYouTubeEmbededCode } from "@/utils/CommonUtils.js"

export default {
	name: "NewsAndAnnouncementThumbnailSection",
	props: ["data"],
	methods: {
		getYouTubeUrl(url) {
			if (url !== null) {
				return getYouTubeEmbededCode(url)
			}
		},
		isYouTubeLink(link) {
			return link.includes("youtube.com")
		},
	},
}
</script>

<style scoped lang="scss">
.card-img, .card-img-top {
  width: 100%;
  height: 200px;
  object-fit: contain;
}
.video-container {
  height: 185px;
}
</style>